export default __webpack_public_path__ + "static/image-3289d2692706012c6eafcd0a8b07e61c.jpg";